import { useState } from "react"
import { Textareawithsteroids, Textareawithsteroids2 } from "../ESG/EnvironmentReport"
import { HeaderShow } from "../ESG/ESGmain"

const Step7 = () => {
    const [showContent,setShowContent] = useState(false)
    const subtext = `Now we need to implement the new train of thought and effort into the business as a whole`

    const actiontext = `Use the new defined values and business models to rewrite the mission, vision and strategy`
    const exercisetext = `Let everyone give their input to vision and mission and state their point on values.`
    return ( 
        <div className="d-flex flex-column align-items-center mt-2">
        <HeaderShow text={"Step 7 Cross-Corporation Effort"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
        
        {
            showContent ?
            <>
            <div className="roleambition__bubble w-90 mt-3 ms-0">
                <h5>{subtext}</h5>
                <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex flex-column me-5">
                        <h5 style={{textAlign:"center"}}><b>Action</b></h5>
                        <h5>{actiontext}</h5>
                    </div>
                    <div className="d-flex flex-column">
                        <h5 style={{textAlign:"center"}}><b>Exercise</b></h5>
                        <h5>{exercisetext}</h5>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-around w-90">
                <div className="sdg__action__exercise">
                    <h4>Action:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step7_action"}
                    />        
                </div>
                <div className="sdg__action__exercise">
                    <h4>Exercise:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step7_exercise"}
                    />        
                </div>
            </div>
            <div className="sdg__action__exercise w-85">
                <h4>Write in your conclusions here:</h4><Textareawithsteroids2   
                    maxLength={3000}
                    keyHighlight={"step7_conclusion"}
                />        
            </div>
            </>:null
        }
        </div>
     );
}
 
export default Step7;